import { FormattedMessage } from "react-intl";
import { Flex, Text } from "@paguelofacil/pf-components";
import { language, languageDefault } from "../../services/utils/Language";

import { Timer } from "../Timer/index";

export const CardInfoTime = ({ onFinishTimer, initialSecondsTimer, isResetClock }) => {
    return (
        <Flex className="card-information-timer" minW="auto" gap="0.25rem">
            <Flex justify="space-between" direction="row" wrap="nowrap">
                <Text weight="regular" variant="body6">
                    <FormattedMessage id={language.rest_time} defaultMessage={languageDefault.rest_time} />:
                </Text>
                <Timer isReset={isResetClock} onFinish={onFinishTimer} initialSeconds={initialSecondsTimer} />
            </Flex>
            <Flex direction="column" align="flex-start" gap="0">
                <Text style={{ fontSize: "0.75rem", color: "#515A69" }} weight="regular" variant="body6">
                    <FormattedMessage
                        id={language.will_freeze_price}
                        defaultMessage={languageDefault.will_freeze_price}
                    />
                </Text>
                <Text style={{ fontSize: "0.75rem", color: "#515A69" }} weight="regular" variant="body6">
                    <FormattedMessage
                        id={language.if_not_do_tx_price_change}
                        defaultMessage={languageDefault.if_not_do_tx_price_change}
                    />
                </Text>
            </Flex>
        </Flex>
    );
};
